// extracted by mini-css-extract-plugin
export default {"header":"styles_header__RuhIG","body":"styles_body__ZOCVQ","numerator":"styles_numerator__dQevo","line":"styles_line__-z+3B","titleContainer":"styles_titleContainer__L9TTj"};